// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getSystemList, SystemListApiParameter, SystemListCollectionModel } from "@werner/App/Services/SystemListService";

type HandlerType = ApiHandler<SystemListApiParameter & HasOnSuccess & HasOnError<string>, SystemListCollectionModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { systemListName: props.parameter.systemListName };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getSystemList(props.apiParameter);
    } catch (error) {
        props.parameter.onError?.(error.errorMessage);
        return false;
    }
};

export const DispatchCompleteLoadSystemList: HandlerType = (props: any) => {
    props.dispatch({
        type: "xSystemLists/CompleteLoadSystemList",
        systemList: props.apiResult,
        parameter: props.parameter,
    });
};

export const OnSuccess: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.();
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadSystemList, OnSuccess];

const loadSystemList = createHandlerChainRunner(chain, "LoadSystemList");
export default loadSystemList;
